module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-mail-a05463e64d0713f00533f39d280c41c0.svg";